import { ref, onMounted, onUnmounted } from '@nuxtjs/composition-api'

export function useAfkDetector(onUserReturn: () => void, afkTimeout = 30 * 60 * 1000) {
  const isAfk = ref(false)
  let timeoutId: number | null = null

  const resetAfkTimer = () => {
    if (isAfk.value) {
      isAfk.value = false
      onUserReturn()
    }
    if (timeoutId !== null) {
      clearTimeout(timeoutId)
    }
    timeoutId = window.setTimeout(() => {
      isAfk.value = true
    }, afkTimeout)
  }

  const registerActivityListeners = () => {
    window.addEventListener('mousemove', resetAfkTimer)
    window.addEventListener('keydown', resetAfkTimer)
    window.addEventListener('touchstart', resetAfkTimer)
    window.addEventListener('click', resetAfkTimer)
  }

  const unregisterActivityListeners = () => {
    window.removeEventListener('mousemove', resetAfkTimer)
    window.removeEventListener('keydown', resetAfkTimer)
    window.removeEventListener('touchstart', resetAfkTimer)
    window.removeEventListener('click', resetAfkTimer)
  }

  onMounted(() => {
    registerActivityListeners()
    resetAfkTimer()
  })

  onUnmounted(() => {
    unregisterActivityListeners()
    if (timeoutId !== null) {
      clearTimeout(timeoutId)
    }
  })
}
